import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StoryMap from './StoryMap';

import wuhanImg from '../img/Wuhan.jpg';
import bangkokImg from '../img/Bangkok.jpg';
import seoulImg from '../img/Seoul.jpg';
import usaImg from '../img/USA.jpg';
import breakingNewsImg from '../img/BreakingNews.jpg';
import bbcNewsImg from '../img/BBCNews.jpg';
import coronavirusImg from '../img/Coronavirus.jpg';


export default class InfoLanding extends React.Component {

  constructor() {
    super();
    this.state = {
      scrolledOnce: false,
      step: 0,
      viewport: {
        width: '100%',
        height: '100%',
      },
      markers: [],
      popups: [],
    };
  }
  componentDidMount() {
    this.setState({
      scrolledOnce: false,
      step: 0,
      viewport: {
        width: '100%',
        height: '100%',
      },
      markers: [],
      popups: [],
    });
    window.addEventListener('wheel', (e) => {
      if (!this.state.scrolledOnce) {
        this.setState({scrolledOnce: true});
        setTimeout((() => this.setState({scrolledOnce: false})), 3000);
        this.nextStep();
      }
    });
    this.runStep();
  }

  renderSwitch() {
    switch(this.state.step) {
      case 0: {
        return (
          <div className='history-card'>
            <h3>
              В конце декабря 2019 года
            </h3>
            <p>
            китайские власти сообщили о вспышке пневмонии 
            неизвестного происхождения в городе Ухань. Первые заболевшие имели 
            отношение к рынку морепродуктов. Эксперты предварительно установили, 
            что возбудителем заболевания стал новый тип коронавируса - 2019-nCoV.
            </p>
          </div>
        );
      }
      case 1: {
        return (
          <div className='history-card'>
            <h3>
              Первый случай
            </h3>
            <p>
            за пределами Китая стал известен 13 января. Это была 
            61-летняя женщина, которая прилетела из Уханя 8 января в Бангкок 
            (Таиланд). К 18 января количество случаев за пределами Китая 
            увеличилось до трёх случаев (два в Таиланде, один в Японии).
            </p>
          </div>
        );
      }
      case 2: {
        return (
          <div className='history-card'>
            <h3>
            20 января
            </h3>
            <p>
             китайские власти сообщили о резком увеличении числа 
            новых случаев заболевания, вызванного коронавирусной 
            инфекцией COVID-19, сразу на 140 новых пациентов; 
            некоторые из них оказались за пределами Уханя — в Шэньчжэне 
            и Пекине. Также сообщалось о ещё одной смерти, вызванной 
            вирусом, и о первом случае заболевания в Южной Корее. 
            Китайские власти официально подтвердили, что имели место 
            случаи передачи инфекции от человека к человеку.
            </p>
          </div>
        );
      }
      case 3: {
        return (
          <div className='history-card'>
            <h3>
              21 января
            </h3>
            <p>
             у американца, который вернулся из Уханя в Сиэтл (США) 
            15 января, была диагностирована первая инфекция COVID-19 года 
            за пределами Азии.
            </p>
          </div>
        );
      }
      case 4: {
        return (
          <div className='history-card'>
            <h3>
              В феврале 2020 года
            </h3>
            <p>
            инфекция начала быстро распространяться 
            по разным странам, несмотря на принимаемые властями Китая 
            карантинные меры. 11 марта 2020 года ВОЗ объявила, что 
            вспышка приобрела характер пандемии. В то же время, 
            в самом Китае со вспышкой инфекции ко второй половине марта 
            удалось в основном справиться. Прямо сейчас в мире насчитывается
            более 800 тысяч заражённых.
            </p>
            <p><a href='/#'>Пожертвовать средства на борьбу с коронавирусом</a></p>
          </div>
        );
      }
      default: return null;
    }
  }

  nextStep() {
    if (this.state.step + 1 < 5) {
      this.setState(prevState => {
        return {
          step: prevState.step+1,
        };
      });
      this.runStep();
    }
  }

  runStep() {
    switch(this.state.step) {
      case 0: {
        this.setState((prevState) => ({
          viewport: {
            ...prevState.viewport,
            latitude: 30.58333,
            longitude: 114.26667,
            zoom: 5,
          },
          markers: [
            {
              latitude: 30.58333,
              longitude: 114.26667,
              text: '🐠'
            }
          ],
          popups: [
            {
              latitude: 30.58333,
              longitude: 114.26667,
              img: wuhanImg,
              jsx: <p className='popup'>Используйте колесо мыши <FontAwesomeIcon icon='mouse' className='popup-icon' /></p>,
            },
          ]
        }));
        break;
      }
      case 1: {
        const wishedLatitude = 13.736717;
        const wishedLongitude = 100.523186;
        const self = this;
        function animate() {
          if (self.state.viewport.latitude > wishedLatitude) {
            self.setState((prevState) => ({
              viewport: {
                ...prevState.viewport,
                latitude: prevState.viewport.latitude - 0.3,
              },
              markers: [
                {
                  ...prevState.markers[0],
                  latitude: prevState.viewport.latitude - 0.3,
                  text: '✈️',
                },
                {
                  latitude: 30.58333,
                  longitude: 114.26667,
                  text: '🐠'
                }
              ],
              popups: [],
            }));
          }
          if (self.state.viewport.longitude > wishedLongitude) {
            self.setState((prevState) => ({
              viewport: {
                ...prevState.viewport,
                longitude: prevState.viewport.longitude - 0.3,
              },
              markers: [
                {
                  ...prevState.markers[0],
                  longitude: prevState.viewport.longitude - 0.3,
                  text: '✈️',
                },
                {
                  latitude: 30.58333,
                  longitude: 114.26667,
                  text: '🐠'
                }
              ],
              popups: [],
            }));
          }
          if (!(self.state.viewport.longitude < wishedLongitude && self.state.viewport.latitude < wishedLatitude)) {
            requestAnimationFrame(animate);
          } else {
            self.setState((prevState) => ({
              markers: [
                {
                  latitude: 13.736717,
                  longitude: 100.523186,
                  text: '🦠'
                }
              ],
              popups: [
                {
                  latitude: wishedLatitude,
                  longitude: wishedLongitude,
                  img: bangkokImg,
                }
              ]
            }));
          }
        }
        requestAnimationFrame(animate);
        break;
      }
      case 2: {
        const wishedLatitude = 37.532600;
        const wishedLongitude = 127.024612;
        const self = this;
        this.setState((prevState) => ({
          viewport: {
            ...prevState.viewport,
            latitude: 30.58333,
            longitude: 114.26667,
            zoom: 5,
          },
          markers: [
            {
              latitude: 30.58333,
              longitude: 114.26667,
              text: '🐠'
            }
          ]
        }));
        function animate() {
          if (self.state.viewport.latitude < wishedLatitude) {
            self.setState((prevState) => ({
              viewport: {
                ...prevState.viewport,
                latitude: prevState.viewport.latitude + 0.3,
              },
              markers: [
                {
                  ...prevState.markers[0],
                  latitude: prevState.viewport.latitude + 0.3,
                  text: '✈️',
                },
                {
                  latitude: 30.58333,
                  longitude: 114.26667,
                  text: '🐠'
                }
              ]
            }));
          }
          if (self.state.viewport.longitude < wishedLongitude) {
            self.setState((prevState) => ({
              viewport: {
                ...prevState.viewport,
                longitude: prevState.viewport.longitude + 0.3,
              },
              markers: [
                {
                  ...prevState.markers[0],
                  longitude: prevState.viewport.longitude + 0.3,
                  text: '✈️',
                },
                {
                  latitude: 30.58333,
                  longitude: 114.26667,
                  text: '🐠'
                }
              ]
            }));
          }
          if (!(self.state.viewport.longitude > wishedLongitude && self.state.viewport.latitude > wishedLatitude)) {
            requestAnimationFrame(animate);
          } else {
            self.setState((prevState) => ({
              markers: [
                {
                  latitude: 37.532600,
                  longitude: 127.024612,
                  text: '🦠'
                }
              ],
              popups: [
                {
                  latitude: wishedLatitude,
                  longitude: wishedLongitude,
                  img: seoulImg,
                }
              ]
            }));
          }
        }
        requestAnimationFrame(animate);
        break;
      }
      case 3: {
        const wishedLatitude = 47.608013;
        const wishedLongitude = -122.335167;
        const self = this;
        this.setState((prevState) => ({
          viewport: {
            ...prevState.viewport,
            latitude: 30.58333,
            longitude: 114.26667,
            zoom: 1,
          },
          markers: [
            {
              latitude: 30.58333,
              longitude: 114.26667,
              text: '🐠'
            }
          ],
          popups: [],
        }));
        console.log('got to wuhan');
        function animate() {
          console.log('starting animation');
          if (self.state.viewport.latitude < wishedLatitude) {
            console.log('changing latitude');
            self.setState((prevState) => ({
              viewport: {
                ...prevState.viewport,
                latitude: prevState.viewport.latitude + 0.9,
              },
              markers: [
                {
                  ...prevState.markers[0],
                  latitude: prevState.viewport.latitude + 0.9,
                  text: '✈️',
                },
                {
                  latitude: 30.58333,
                  longitude: 114.26667,
                  text: '🐠',
                }
              ]
            }));
          }
          if (self.state.viewport.longitude > wishedLongitude) {
            console.log('changing longitude');
            self.setState((prevState) => ({
              viewport: {
                ...prevState.viewport,
                longitude: prevState.viewport.longitude - 0.9,
              },
              markers: [
                {
                  ...prevState.markers[0],
                  longitude: prevState.viewport.longitude - 0.9,
                  text: '✈️',
                },
                {
                  latitude: 30.58333,
                  longitude: 114.26667,
                  text: '🐠',
                }
              ]
            }));
          }
          if (!(self.state.viewport.longitude < wishedLongitude && self.state.viewport.latitude > wishedLatitude)) {
            requestAnimationFrame(animate);
            console.log('animating');
          } else {
            console.log('ending animation');
            self.setState((prevState) => ({
              markers: [
                {
                  latitude: wishedLatitude,
                  longitude: wishedLongitude,
                  text: '🦠',
                }
              ],
              popups: [
                {
                  longitude: wishedLongitude,
                  latitude: wishedLatitude,
                  img: usaImg,
                }
              ]
            }));
          }
        }
        requestAnimationFrame(animate);
        break;
      }
      case 4: {
        this.setState({
          popups: [],
        });
        fetch('https://covid-api.quintessential.gr/data')
          .then(res => res.json())
          .then(array => {

            array = array.filter(e => e.Latitude.length > 0);
            array.forEach(e => {
              e['text'] = '🦠';
              e['longitude'] = parseFloat(e.Longitude);
              e['latitude'] = parseFloat(e.Latitude);
            });
            console.log(array);
            this.setState((prevState) => ({
              viewport: {
                ...prevState.viewport,
                zoom: 1,
                longitude: 0,
                lattitude: 0,
              },
              markers: [
                {
                  latitude: 30.58333,
                  longitude: 114.26667,
                  text: '🐠',
                },
                ...array,
              ],
              popups: [
                {
                  latitude: 51.509865,
                  longitude: -0.118092,
                  img: bbcNewsImg,
                },
                {
                  latitude: 38.89511,
                  longitude: -77.03637,
                  img: breakingNewsImg,
                },
                {
                  latitude: 47.921230,
                  longitude: 106.918556,
                  img: coronavirusImg,
                }
              ],
            }));
          });
        break;
      }
      default: return null;
    }
  }

  render() {
    return (
      <div className='content'>
      <div className='mainmap'>
        <StoryMap 
          data={this.state.data}
          viewport={this.state.viewport} 
          markers={this.state.markers}
          popups={this.state.popups}
          />
      </div>
      <div className='infocontent'>

        {this.renderSwitch()}

      </div>
    </div>
    );
  }
}
